<template>
	<div class="file-preview" :class="mode">
		<component
			:is="previewComponent.component"
			v-if="computedFileUrl && previewComponent"
			:url="computedFileUrl"
			v-bind="previewComponent.props"
			@click.stop
		/>
		<span v-else-if="!previewComponent" class="preview-message" @click.stop
			>We kunnen dit bestand niet laten zien</span
		>
	</div>
</template>

<script lang="ts" setup>
import { FileType } from "@/enums/FileType";
import { getFileType } from "@/helpers/fileHelpers";
import { computed } from "vue";
import PdfView from "@/components/PdfView.vue";
import FilePreviewImage from "./FilePreviewImage.vue";

const props = withDefaults(
	defineProps<{
		fileBlob?: Blob;
		fileUrl?: string;
		contentType?: string;
		mode?: "full" | "thumbnail";
		byteSize?: number;
	}>(),
	{ mode: "full" },
);

const isLargePdf = computed(
	() => fileType.value === FileType.Pdf && (props.byteSize ?? 0) > 10_000_000,
);

const fileType = computed(() =>
	getFileType(props.contentType ?? props.fileBlob?.type),
);
const computedFileUrl = computed(() => {
	if (props.fileBlob) {
		return URL.createObjectURL(props.fileBlob);
	}

	return props.fileUrl;
});

const previewComponent = computed<{ component: any; props?: any } | null>(
	() => {
		switch (fileType.value) {
			case FileType.Pdf:
				return {
					component: PdfView,
					props: {
						pageWrapper: "div",
						mode: props.mode,
						limitPages: isLargePdf.value,
					},
				};
			case FileType.Img:
			case FileType.Svg:
				return { component: FilePreviewImage };
			default:
				return null;
		}
	},
);
</script>

<style lang="scss">
.file-preview.thumbnail {
	.preview-message {
		display: none;
	}

	.file-preview-image,
	canvas {
		filter: drop-shadow(0px 0px 2px var(--text-muted));
		border-radius: var(--border-radius);
	}
}

.file-preview.full {
	text-align: center;

	.preview-message {
		margin-top: 20rem;
		color: #fff;
		display: block;
	}
}
</style>
